import type { Result, AppError } from '../../error/types';
import { isEnvironment } from './isEnvironment';
import { ENVIRONMENTS } from '../constants/ENVIRONMENTS';

/**
 * @group Functions
 * @summary <blockquote>Checks if the current environment is production.</blockquote>
 * 
 * @returns Result containing true if production, false otherwise
 * 
 * @example
 * ```typescript
 * import { isProduction } from '@shared/utils';
 * 
 * const result = isProduction();
 * result.match({
 *   ok: (isProd) => isProd && console.log('Production mode'),
 *   err: (error) => console.error(`Check failed: ${error.errorMessage}`)
 * });
 * ```
 */
export function isProduction(): Result<boolean, AppError> {
  return isEnvironment(ENVIRONMENTS.PRODUCTION);
}